module.exports = __webpack_public_path__ + "img/step03_a_stand_basic_left_front_leg.e9204416.png";